<template>
  <div class="page-container text-center">
    <div v-if="showScanner">
      <scan-code message="Hover over a location or encounter space to scan it"
        @onScannedCode="handleScannedCode" />
    </div>
    <div v-else>
      <h2 class="sub-heading">Investigating {{$store.state.currentGame.quest.name}}</h2>
      <figure>
        <img :src="$store.state.currentGame.character.avatar.fields.file.url + '?q=50'"
          :alt="$store.state.currentGame.character.name" />
        <figcaption>
          Playing as {{$store.state.currentGame.character.name}}
        </figcaption>
      </figure>
      <div class="icon-row">
        <figure
          class="icon-row__icon icon-row__icon--borderbox"
          @click="showScanner = true">
          <font-awesome-icon icon="search" class="fa-2x" style="margin: 1rem" />
          <figcaption>Scan</figcaption>
        </figure>
        <figure
          class="icon-row__icon icon-row__icon--borderbox"
          @click="$router.push('/quest/clues')">
          <font-awesome-icon icon="file-alt" class="fa-2x" style="margin: 1rem" />
          <figcaption>Review Clues</figcaption>
        </figure>
        <figure
          class="icon-row__icon icon-row__icon--borderbox"
          @click="$router.push('/quest/info')">
          <font-awesome-icon icon="question" class="fa-2x" style="margin: 1rem" />
          <figcaption>Read Quest</figcaption>
        </figure>
      </div>
      <icon-buttons close="/exit" />
    </div>
  </div>
</template>
<script>
import ScanCode from '../../components/device/ScanCode.vue';
import IconButtons from '@/components/IconButtons.vue';

export default {
  data() {
    return {
      showScanner: false,
      scanResult: '',
    };
  },
  components: {
    ScanCode,
    IconButtons,
  },
  methods: {
    handleScannedCode(code) {
      this.showScanner = false;
      this.scanResult = code;
      if (code === 'fake') {
        this.$store.commit('setCurrentLocation', this.$store.state.currentGame.locations[0]);
        this.$router.push('/location');
      } else if (code === 'cancelled') {
        this.$store.commit('clearCurrentLocation');
        this.$router.push('/start');
      } else if (code.startsWith('location-')) {
        const name = code.replace('location-', '');
        const location = this.$store.state.currentGame.locations.find(l => l.name === name);
        this.$store.commit('setCurrentLocation', location);
        this.$router.push('/location');
      } else if (code.startsWith('encounter-')) {
        const { encounters } = this.$store.state.currentGame;
        const encounterIndex = Math.floor(Math.random() * Math.floor(encounters.length));
        this.$store.commit('setCurrentEncounter', encounters[encounterIndex]);
        this.$router.push('/encounter');
      } else {
        throw new Error(`cannot resolve scan result: ${code}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  width: 250px;
}
</style>
